// @flow
import React from "react"
import { connect } from "react-redux"
import type { Params } from "react-router"
import * as R from "ramda"

import * as globalActions from "../../services/params/actions"

type OwnProps = {
  // eslint-disable-next-line flowtype/no-weak-types
  routes: any, // i have no idea where this is from
  params: Params, // react-router
  query: { [string]: string },
  children?: any, // eslint-disable-line flowtype/no-weak-types
}

type Props = OwnProps & {
  updateRoute: typeof globalActions.updateRoute,
}

class UpdateRoute extends React.PureComponent<Props> {
  componentDidMount() {
    const { updateRoute, params, routes, query } = this.props

    updateRoute(params, routes, query)
  }

  componentWillUpdate(nextProps: Props) {
    const { updateRoute, params, query, routes } = this.props

    const paramsEq = R.equals(params, nextProps.params)
    const queryEq = R.equals(query, nextProps.query)
    const routesEq = R.equals(
      routes.map(route => route.name).filter(Boolean),
      nextProps.routes.map(route => route.name).filter(Boolean),
    )
    if (!paramsEq || !routesEq || !queryEq) {
      updateRoute(nextProps.params, nextProps.routes, nextProps.query)
    }
  }

  render() {
    return this.props.children || null
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  null,
  {
    updateRoute: globalActions.updateRoute,
  },
)(UpdateRoute)
